import { render, staticRenderFns } from "./InvestmentAccountTypeFeeDetails.vue?vue&type=template&id=85dae8b4"
import script from "./InvestmentAccountTypeFeeDetails.vue?vue&type=script&lang=ts"
export * from "./InvestmentAccountTypeFeeDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports